<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">资产管理</h1>
			<div class="clear">
				
				<el-select class="" @change="clickCom()" value-key="uid" v-if="administrators==3 || administrators==5" v-model="selectComId" placeholder="请选择公司">
					<el-option label="所有公司" key="-1" value=""></el-option>
		          <el-option v-for="com in comList" :label="com.company" :key="com.uid" :value="com.company_id"></el-option>
		        </el-select>
		        <el-select class="" v-model="selectCateId" placeholder="请选择类别">
		          <el-option v-for="(area,index) in cateList" :label="area.category" :key="index" :value="area.category"></el-option>
		        </el-select>
		        <input placeholder="请输入要搜索的资产编号" v-model="asset_nid" class="log-input search-input mt0" />
		        <el-button @click="getDeviceList()"> 搜 索 </el-button>
		        <el-upload
				  class="importAsset"
				  name="upfile"
				  :data="filePara"
				  :action='upFileUrl'
				  :on-change="handleChange"
				  :on-success="handleAvatarSuccess"
			        :on-exceed="handleExceed"
			        :on-error="imgUploadError"
				  :file-list="fileList">
				  <el-button type="primary">EXCEL导入资产</el-button>
				  
				</el-upload>
				<a class="el-button el-button--text el-button--small" target="_blank" :href='$store.state.domain2+"/static/PHPExcel/assets.xls"'>下载示例文档</a>
		        
			</div>
			<el-table
		    	stripe
				border
			    ref="multipleTable"
			    :data="cDevList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="50">
			    </el-table-column>
			    <el-table-column
			      prop="nid"
			      label="资产编号"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="name"
			      label="资产名称">
			    </el-table-column>
			    <el-table-column
			      prop="category"
			      label="类别"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="model"
			      label="型号"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="maintain_expire"
			      label="维保到期时间"
			      :formatter="dateFormat">
			    </el-table-column>
			    <el-table-column
		          label="操作"
		          show-overflow-tooltip>
		          <template slot-scope="scope">
		            <el-button type="text" size="small"
		                       @click="clickMod(scope.$index, scope.row)"> 详情修改 
		            </el-button>
		            
		            <el-button type="text" size="small"
		                       @click="unbindClick(scope.$index, scope.row)"> 删除 
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
	  			<br />
				<div class="text-right">
					<el-pagination
						@current-change="handleCurrentChange"
					  :page-size="pagesize"
					  layout="total, prev, pager, next"
					  :total="totalNum">
					</el-pagination>
				</div>
		</div>
		<!--删除资产-->
		<el-dialog title="删除资产" :visible.sync="unbindAdminFlag" width="500px">
        
	        <el-form label-position="">
	        	<el-form-item label="资产名称：" :label-width="formLabelWidth">
			    	<span v-text="unbindDevice.name"></span>
			    </el-form-item>
	            <el-form-item label="资产类别：" :label-width="formLabelWidth">
			    	<span v-text="unbindDevice.category"></span>
			    </el-form-item>
			    <el-form-item label="型号：" :label-width="formLabelWidth">
			    	<span v-text="unbindDevice.model"></span>
			    </el-form-item>
	        </el-form>
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="unbindAdminFlag=false">取 消</el-button>
	          <el-button type="primary" @click="unbindAdmin()">确定删除</el-button>
	        </div>
	    </el-dialog>
	    <!--修改资产信息-->
		<el-dialog title="修改资产信息" :visible.sync="devDialogFlag" width="500px" >
		    <el-form label-width="120px">
	        	<el-form-item label="资产名称：">
			    	<el-input v-model="modDev.name" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="资产编号：">
			    	<el-input v-model="modDev.nid" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="设备类别：">
			    	<el-select class="" v-model="modDev.category" placeholder="请选择类别">
			          <el-option v-for="(area,index) in cateList" :label="area.category" :key="index" :value="area.category"></el-option>
			        </el-select>
			    </el-form-item>
			    <el-form-item label="厂商：">
			    	<el-select class="" v-model="modDev.manufacturer_id" placeholder="请选择类别">
			          <el-option v-for="(manufac,index) in manufacList" :label="manufac.name" :key="index" :value="manufac.id"></el-option>
			        </el-select>
			    </el-form-item>
			    <el-form-item label="型号：">
			    	<el-input v-model="modDev.model" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="维保单位：">
			    	<el-select class="" v-model="modDev.maintainer_id" placeholder="请选择类别">
			          <el-option v-for="(maintainer,index) in maintainerList" :label="maintainer.name" :key="index" :value="maintainer.id"></el-option>
			        </el-select>
			    </el-form-item>
			    <el-form-item label="维保到期时间：">
			    	<el-date-picker
				      v-model="modDev.maintain_expire"
				      class="width300"
				      value-format="yyyy-MM-dd"
				      placeholder="选择日期">
				    </el-date-picker>
			    </el-form-item>
			    <el-form-item label="位置：">
			    	<el-input v-model="modDev.position" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="具体位置：">
			    	<el-input v-model="modDev.building" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="购置时间：">
			    	<el-date-picker
				      v-model="modDev.bought_time"
				      class="width300"
				      value-format="yyyy-MM-dd"
				      placeholder="选择日期">
				    </el-date-picker>
			    </el-form-item>
			    <el-form-item label="IP地址：">
			    	<el-input v-model="modDev.ip" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="MAC地址：">
			    	<el-input v-model="modDev.mac_addr" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="备注：">
			    	<el-input type="textarea" v-model="modDev.remarks"></el-input>
			    </el-form-item>
	            
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="cancelChangeName()">取消</el-button>
			    <el-button type="primary" @click="confirmModify()">确定</el-button>
			  </div>
		</el-dialog>
		<!--错误提示弹框表格-->
		<el-dialog title="错误详情" :visible.sync="warnFlag" width="700px">
        	<el-table
		    	stripe
		    	border
		    	height="450"
			    ref="multipleTable"
			    :data="warnList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      prop="row"
			      label="行数"
			      width="70"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="nid"
			      width="120"
			      label="资产编号">
			    </el-table-column>
			    <el-table-column
			      prop="name"
			      label="资产名称"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="error"
			      label="错误信息"
			      width="300"
			      show-overflow-tooltip>
			    </el-table-column>
			    
			  </el-table>
	        
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="warnFlag=false">关 闭</el-button>
	        </div>
	    </el-dialog>
	    <loading v-if="showLoading"></loading>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				if(this.administrators==3 || this.administrators==5){
					this.getCompanyList();
				}
				this.clickCom();
				this.getDeviceList();
				this.getManufacList();
				this.getMaintaList();
				
		  	})
    	},
    	data(){
    		return{
    			fileList:[],
    			cDevList:[],
    			nowPage:1,
    			totalNum:0,
    			pagesize:12,
    			comList:[],
    			selectComId:this.getCookie('company_id'),
    			selectCom:{},
    			selectCateId:null,
    			cateList:[],
    			manufacList:[],
    			maintainerList:[],
    			asset_nid:"",
    			unbindAdminFlag:false,
    			formLabelWidth:"100px",
    			unbindDevice:{},
    			showLoading:false,
    			administrators:this.getCookie('administrators'),
    			devDialogFlag:false,
    			modDev:{
		  		},
		  		upFileUrl:this.$store.state.domain2+"/admin/AssetsManage/AssetsImport",
		  		filePara:{
		  			company_id:this.selectComId || this.getCookie('company_id'),
		  		},
		  		warnList:[],
		  		warnFlag:false
    		}
    	},
    	methods:{
//			点击修改
			clickMod(index,row){
				
				this.devDialogFlag = true;
				
				let clickModParams={
					uid: this.getCookie('uid'),
					id: row.id || "",
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(clickModParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AssetsManage/AssetsDetail",this.$qs.stringify(clickModParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.modDev = res.data.data;
		        		if(this.modDev.maintain_expire){
		        			this.modDev.maintain_expire = this.dateFormat2(this.modDev.maintain_expire);
		        		}
		        		if(this.modDev.bought_time){
		        			this.modDev.bought_time = this.dateFormat2(this.modDev.bought_time);
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			//取消编辑名称
			cancelChangeName(){
				this.devDialogFlag = false;
			},
    		getDeviceList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id:this.selectComId || "",
					category:this.selectCateId || "",
					nid:this.asset_nid || "",
					page:this.nowPage,
					pagesize:this.pagesize,
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
			  		
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AssetsManage/AssetsList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		if(res.data.data.datalist){
		        			this.cDevList = res.data.data.datalist || [];
		        			this.totalNum = res.data.data.totalNumber;
		        		}
		        		
		        		
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
		  		this.asset_nid = "";
		  		
			},
//			获取公司列表
			getCompanyList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		type:2,
		  			company_id:this.getCookie('company_id'),
		  			page:"1",
	  				pagesize:"9999",
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AdministratorsList/AdministratorsList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 & res.data.data!=null){
		        		if(res.data.data.name){
		        			this.comList = res.data.data.name || [];
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			获取可用厂商列表
			getManufacList(){
				let manufacListParams={
					uid:this.getCookie('uid'),
			  		token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(manufacListParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Manufacturer/ManufacturerShow",this.$qs.stringify(manufacListParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200){
		        		this.manufacList = res.data.data || [];
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			获取可用维保单位
			getMaintaList(){
				let getMaintaListParams={
					uid:this.getCookie('uid'),
			  		token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(getMaintaListParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Maintainer/MaintainerShow",this.$qs.stringify(getMaintaListParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200){
		        		this.maintainerList = res.data.data || [];
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			确认修改设备信息
			confirmModify(){
				let modifyParams={
					uid:this.getCookie('uid'),
					id: this.modDev.id,
					name: this.modDev.name,
					nid: this.modDev.nid,
					category: this.modDev.category,
					manufacturer_id: this.modDev.manufacturer_id,
					model: this.modDev.model,
					maintainer_id: this.modDev.maintainer_id,
					maintain_expire: Date.parse(this.modDev.maintain_expire)/1000,
					position: this.modDev.position,
					building: this.modDev.building,
					bought_time: Date.parse(this.modDev.bought_time)/1000,
					ip: this.modDev.ip,
					mac_addr: this.modDev.mac_addr,
					remarks: this.modDev.remarks,
					
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(modifyParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AssetsManage/UpdateAssets",this.$qs.stringify(modifyParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.devDialogFlag = false;
		        	if(res.data.code==200){
		        		this.getDeviceList();
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			点击选择公司
			clickCom(){
//				点击公司后MAC地址设为空
				this.asset_nid = "";
//				点击公司后赋值当前选中区域为空
				this.selectCateId = null;
				this.nowPage = 1;
				//超级管理员和普通管理员分别管理
				if(this.administrators==3 || this.administrators==5){
					//点击赋值当前选中公司
					for(var i=0;i<this.comList.length;i++){
						if(this.comList[i].company_id == this.selectComId){
							this.selectCom = this.comList[i];
						}
					}
					this.filePara.company_id=this.selectComId || "";
					
				}else{
					this.selectCom.uid = this.getCookie('uid');
				}

				let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id:this.selectComId || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AssetsManage/AssetsCategory",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 && res.data.data!=null){
		        		this.cateList = res.data.data
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			分页点击事件
			handleCurrentChange(val){
				this.nowPage = val;
				this.getDeviceList();
			},
//			根据MAC地址搜索
			searchByMac(){
				this.selectComId = null;
				this.selectCateId = null;
				this.getDeviceList();
			},

//			点击删除
			unbindClick(index,row){
				this.unbindAdminFlag = true;
				this.unbindDevice = row;
			},
//			确认删除
			unbindAdmin(){
				this.unbindAdminFlag = false;
				this.showLoading = true;
				let valiCodeParams={
					uid: this.getCookie('uid'),
					id: this.unbindDevice.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AssetsManage/AssetsDelete",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		setTimeout(()=>{
		        			this.getDeviceList();
		        		},500)
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
		  		
			},
			handleChange(file, fileList) {
		        this.fileList = fileList.slice(-1);
		     },
		     handleAvatarSuccess(res, file) {//文件上传成功
		     	if(res.code==200){
		     		this.$message.success(res.msg);
		     		this.getDeviceList();
		     	}else{
		     		this.$message.error(res.msg);
		     		this.warnFlag = true;
		     		this.warnList = res.data;
		     	}
		      },
		      handleExceed(files, fileList) {//上传超过数量限制
		        this.$message.error('只能上传一个文件!');
		      },
		      imgUploadError(err, file, fileList){//上传失败调用
//		        console.log(err)
		        this.$message.error('文件上传失败!');
		      }
    	}
   }
</script>

<style>
	.search-box3{
		margin-top: -88px;
	}
</style>


// WEBPACK FOOTER //
// src/components/device/assetsManage.vue